export default __webpack_public_path__ + "static/media/1850.384b1e25.png";